import { SessionAction } from "store/types/session.types";
import { GlobalState } from "store/configure-store";
import {
  LOGIN_EMR_SERVER_SUCCESS,
  LoginSuccess,
  LOGOUT_UNAUTHORIZED,
  UserContextActionTypes,
} from "store/types/user-context.types";
import { UserConfiguration } from "model/user-configuration.model";

export interface SessionState {
  eHealthPassword: string;
  accessToken: string;
}

export const initialSessionState: SessionState = {
  eHealthPassword: "",
  accessToken: "",
};
/** ---- SELECTORS ---- */
export const selectEHealthPassword = (state: GlobalState) => {
  return state.sessionContext.eHealthPassword;
};

export const isLoggedIn = (state: GlobalState): boolean => {
  return state.sessionContext.accessToken.length !== 0;
};

/** ---- ACTION HANDLERS ---- */
const newEHealthPassword = (
  state: SessionState,
  eHealthPassword: string
): SessionState => {
  return {
    ...state,
    eHealthPassword: eHealthPassword,
  };
};

const logoutAuthorized = (state: SessionState) => {
  return {
    ...state,
    accessToken: "",
    userConfiguration: new UserConfiguration("", false, false),
  };
};

const loginEmrServerSuccess = (state: SessionState, payload: LoginSuccess) => {
  return {
    ...state,
    accessToken: payload.accessToken,
    userConfiguration: payload.userConfiguration,
  };
};

/** ---- REDUCER ---- */
export const sessionReducer = (
  state = initialSessionState,
  action: SessionAction | UserContextActionTypes
): SessionState => {
  switch (action.type) {
    case "NEW_EHEALTH_PASSWORD":
      return newEHealthPassword(state, action.payload);
    case LOGOUT_UNAUTHORIZED:
      return logoutAuthorized(state);
    case LOGIN_EMR_SERVER_SUCCESS:
      return loginEmrServerSuccess(state, action.payload);
    default:
      return state;
  }
};
